var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2786_5187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5832 8.50008C15.5832 12.4121 12.4119 15.5834 8.49984 15.5834M15.5832 8.50008C15.5832 4.58806 12.4119 1.41675 8.49984 1.41675M15.5832 8.50008H1.4165M8.49984 15.5834C4.58782 15.5834 1.4165 12.4121 1.4165 8.50008M8.49984 15.5834C10.2716 13.6437 11.2785 11.1266 11.3332 8.50008C11.2785 5.87361 10.2716 3.35641 8.49984 1.41675M8.49984 15.5834C6.7281 13.6437 5.72122 11.1266 5.6665 8.50008C5.72122 5.87361 6.7281 3.35641 8.49984 1.41675M1.4165 8.50008C1.4165 4.58806 4.58782 1.41675 8.49984 1.41675",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2786_5187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.207237af0a302d5445ed434c05e8d30c.svg";
export { ForwardRef as ReactComponent };